import moment from 'moment';

export default class DateHelper {
  static getPreviousMonday(date) {
    const prevMonday = date ? new Date(date) : new Date();
    prevMonday.setDate(prevMonday.getDate() - ((prevMonday.getDay() + 6) % 7));
    return prevMonday;
  }

  static getThisWeekStartEnd(formatString = 'YYYY-MM-DD') {
    const thisMonday = DateHelper.getPreviousMonday();
    const startDate = moment(thisMonday).format(formatString);
    const endDate = moment(thisMonday).add(6, 'days').format(formatString);

    return { startDate, endDate };
  }

  static getLastWeekStartEnd(formatString = 'YYYY-MM-DD') {
    const thisMonday = DateHelper.getPreviousMonday();

    const startDate = moment(thisMonday)
      .subtract(7, 'days')
      .format(formatString);

    const endDate = moment(thisMonday).subtract(1, 'days').format(formatString);

    return { startDate, endDate };
  }
}



// WEBPACK FOOTER //
// ./helpers/date-helper.js